import type { PreOrderFlowSuggestion } from "@stockline/shared/types/ai/pre-order-flow-suggestion"
import { PRE_ORDER_FLOW_SUGGESTION_TABLE } from "../../../lib/offline/resources/ai/pre-order-flow-suggestion/db"
import { useAISync } from "../providers/AISyncProvider"

/**
 * AI flow suggestions, optionally scoped to one committed flow (`targetId`).
 * Ordered by `syncId` so the latest proposal is last. Callers filter pending
 * (`acceptedAt == null && declinedAt == null`) and `deletedAt` themselves.
 */
export function usePreOrderFlowSuggestions(
  targetId?: string
): PreOrderFlowSuggestion[] {
  const { reactive } = useAISync()
  return reactive.useQuery<PreOrderFlowSuggestion>(
    PRE_ORDER_FLOW_SUGGESTION_TABLE,
    {
      ...(targetId ? { targetId } : {}),
      orderBy: "syncId",
    }
  )
}
